<div class="container p-5">
    <div class="loading">
        <i class="fas fa-spinner fa-spin"></i>
    </div>
</div>